import type { HTMLAttributes, ReactNode } from 'react';
import styles from './Section.module.css';

type Props = HTMLAttributes<HTMLElement> & {
  alt?: boolean;
  narrow?: boolean;
  children?: ReactNode;
};

export default function Section({
  alt,
  narrow,
  children,
  className,
  ...rest
}: Props) {
  const sectionCls = [styles.section, alt && styles.alt, className]
    .filter(Boolean)
    .join(' ');
  const innerCls = [styles.inner, narrow && styles.narrow].filter(Boolean).join(' ');
  return (
    <section className={sectionCls} {...rest}>
      <div className={innerCls}>{children}</div>
    </section>
  );
}
